var data = {
	"body": "<path d=\"M4.469 8.894a1.179 1.179 0 0 0-.381-.988l-2.819-3.4V4h8.762l6.775 14.856L22.762 4h8.356v.506l-2.412 2.313a.704.704 0 0 0-.269.675v17a.704.704 0 0 0 .269.675l2.356 2.313v.506H19.206v-.506l2.444-2.369c.238-.238.238-.313.238-.675V10.7l-6.794 17.244h-.919L6.275 10.7v11.556c-.069.487.094.975.438 1.325l3.175 3.85v.506h-9v-.5l3.175-3.856c.337-.35.494-.844.406-1.325z\" fill=\"currentColor\"/>",
	"width": 32,
	"height": 32
};
exports.__esModule = true;
exports.default = data;
